<template>
  <div id="contenedor-nuevo-tipo-infraestructura">
    <v-form v-model="formularioValido" ref="agregarNuevoTipoInfraestructura">
      <v-card>
        <v-card-title class="secondary--text">
          Registrar nuevo tipo de infraestructura
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-text-field
            label="Descripción"
            v-model="tipoInfraestructura.descripcion"
            :rules="[mixReglas.requerido]"
            required
          >
          </custom-text-field>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixAgregarTipoInfraestructura"
            :disabled="!formularioValido  || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixTiposInfraestructura from './mixTiposInfraestructura';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'AgregarNuevoTipoInfraestructura',
  mixins: [mixTiposInfraestructura],
  components: {
    CustomTextField,
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      tipoInfraestructura: {
        descripcion: '',
      },
    };
  },
  methods: {
    cerrar() {
      this.limpiarformulario();
      this.$emit('cerrar');
    },
    limpiarformulario() {
      this.$refs.agregarNuevoTipoInfraestructura.reset();
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
